import Faq from "./faq/index.js";
import Home from "./home/index.js";
import searchArea from "./search/area.js";
import searchSchool from "./search/school.js";
import searchStation from "./search/station.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import Info from "./info/index.js";
import column from "./column/index.js";
import Contact from "./contact/index.js";
import SearchMap from "./search/map/index.js";

const pages = () => {
    Faq();
    Home()
    Info();
    searchArea();
    searchSchool();
    searchStation();
    estateIndex();
    estateDetail();
    column();
    Contact();
    SearchMap()
};
export default pages;
